import { PUBLISHED_LESSONS_LIST_PREFIX } from 'app/models/publishedLessonList/constants';

const getPublishedLessonState = (state) =>
  state.get(PUBLISHED_LESSONS_LIST_PREFIX);

export const getCurrentLessonForLesson = (state, id) =>
  getPublishedLessonState(state).currentByMaster.get(id);
